import React from 'react';
import { motion } from 'framer-motion';
import { Star } from 'lucide-react';
const METRICS = [{
  value: '+500',
  label: 'profes confían'
}, {
  value: '12+6',
  label: 'Tomos + Bonus'
}, {
  value: '4.9/5',
  label: 'calificación',
  suffix: '⭐'
}, {
  value: '🇦🇷',
  label: 'Argentina',
  isFlag: true
}];
const TESTIMONIALS = [{
  initials: 'MP',
  quote: 'Organicé todo el mes en una tarde. Nunca más llego a clase sin saber qué dar.',
  name: 'María P., Buenos Aires',
  role: 'Profesora de Yoga en Estudio Propio'
}, {
  initials: 'CG',
  quote: 'Mis alumnos de nivel inicial mejoraron su alineación desde la primera semana con el Tomo 2.',
  name: 'Claudia G., Córdoba',
  role: 'Profesora de Yoga en Academia Privada'
}, {
  initials: 'FR',
  quote: 'Antes tardaba 1 hora armando una secuencia. Ahora son 5 minutos.',
  name: 'Federico R., Rosario',
  role: 'Profesor de Yoga Independiente'
}];
function Stars() {
  return <div className="flex gap-0.5" data-id="element-199">
      {[...Array(5)].map((_, i) => <Star key={i} size={16} className="fill-dorado text-dorado" data-id="element-200" />)}
    </div>;
}
export function SocialProof() {
  return <section className="py-20 px-4 bg-verdeOscuro relative overflow-hidden" data-id="element-201">
      <div className="max-w-6xl mx-auto relative z-10" data-id="element-202">
        {/* Metrics */}
        <div className="grid grid-cols-2 md:grid-cols-4 gap-8 md:gap-4 mb-16" data-id="element-203">
          {METRICS.map((metric, idx) => <motion.div key={idx} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: idx * 0.1
        }} className="text-center" data-id="element-204">
              <div className={`font-extrabold text-white leading-none mb-2 ${metric.isFlag ? 'text-5xl md:text-6xl' : 'text-4xl md:text-6xl'}`} data-id="element-205">
                {metric.value}
              </div>
              <div className="text-dorado text-sm md:text-base font-medium flex items-center justify-center gap-1" data-id="element-206">
                {metric.label}
                {metric.suffix && <span data-id="element-207">{metric.suffix}</span>}
              </div>
            </motion.div>)}
        </div>

        {/* Testimonials */}
        <div className="grid md:grid-cols-3 gap-5" data-id="element-208">
          {TESTIMONIALS.map((t, idx) => <motion.div key={idx} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.2 + idx * 0.1
        }} className="bg-oscuro/60 border border-white/5 rounded-2xl p-6 shadow-lg" data-id="element-209">
              <div className="flex items-start gap-4 mb-4" data-id="element-210">
                <div className="flex-shrink-0 w-11 h-11 rounded-full bg-terracota/20 text-terracota flex items-center justify-center font-bold text-sm" data-id="element-211">
                  {t.initials}
                </div>
                <div className="pt-1.5" data-id="element-212">
                  <Stars data-id="element-213" />
                </div>
              </div>

              <p className="text-white leading-relaxed mb-4 text-[15px]" data-id="element-214">
                "{t.quote}"
              </p>

              <p className="text-gray-400 text-sm leading-snug" data-id="element-215">
                — {t.name} <span className="text-gray-500" data-id="element-216">|</span> {t.role}
              </p>
            </motion.div>)}
        </div>
      </div>
    </section>;
}